export default {
  clientId: '2d2f8f80-7da4-4013-a732-7a2298985ebe',
  authority: 'https://login.microsoftonline.com/875bdd0a-688b-41d2-96b7-454d280043aa',
  scopes: ['user.read'],
}
